import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { parcelProviderTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";

export class AdminParcelStatuses extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id, provider },
                    },
                }) => <Link to={`${paths.adminParcelStatusesShow(id)}?provider=${provider}`}>{value}</Link>,
            },
            { Header: "Внешний ID", accessor: "externalId", filterable: true },
            {
                Header: "Провайдер",
                accessor: "provider",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "provider" },
                            options: parcelProviderTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(parcelProviderTypes, value),
                CSVExport: ({ value }) => enumLabel(parcelProviderTypes, value),
            },
            {
                Header: "Конечный статус",
                accessor: "isFinal",
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Конечный статус", value: "true" },
                        { label: "Промежуточный статус", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} />;
                },
                Cell: ({ value }) => (
                    <div className="text-center">{value ? "Конечный статус" : "Промежуточный статус"}</div>
                ),
                CSVExport: ({ value }) => (value ? "Конечный статус" : "Промежуточный статус"),
            },
            {
                Header: "Положительный статус",
                accessor: "isSuccess",
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Положительный статус", value: "true" },
                        { label: "Негативный статус", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} />;
                },
                Cell: ({ value }) => (
                    <div className="text-center">{value ? "Положительный статус" : "Негативный статус"}</div>
                ),
                CSVExport: ({ value }) => (value ? "Положительный статус" : "Негативный статус"),
            },
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.adminParcelStatusesNew,
        };
        return <Link {...props}>{this.props.createBtnText}</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(AdminParcelStatuses, "admin-parcel-statuses");
